import React, {
  type ComponentType,
  type ReactElement,
  type ReactNode,
} from "react";

export interface TransProps {
  i18nKey?: string;
  components?: ReactElement[] | Record<string, ReactElement>;
}

interface BulletListProps {
  items: (string | ReactNode)[];
  Trans?: ComponentType<TransProps>;
}

export default function BulletList({
  items,
  Trans,
}: BulletListProps): ReactElement {
  const itemsArray = Array.isArray(items) ? items : [];

  return (
    <ul className="space-y-1 text-left">
      {itemsArray.map((item, index) => (
        <li key={index} className="flex items-start gap-1.5 text-white">
          <span>•</span>
          <span>
            {Trans && typeof item === "string" ? (
              <Trans
                i18nKey={item}
                components={[<span key="0" className="font-bold" />]}
              />
            ) : (
              item
            )}
          </span>
        </li>
      ))}
    </ul>
  );
}
